module.exports = __webpack_public_path__ + "media/images/cheers_sent_success_1-535c01dcd07930b6467fb36c458f8a94.gif";